import React from 'react';
import './guia.css';

const Guia = () => {
    const consultasPorRol = [
        {
            title: "CEO",
            consultas: [
                "• Comparte tabla para CEO con KPIs de pricing y su impacto en la rentabilidad global.",
                "• Análisis resumen comparativo de la estrategia de precios vs. Competidores principales.",
                "• Proyección de ingresos y margen basada en escenarios de optimización de precios."
            ]
        },
        {
            title: "CFO",
            consultas: [
                "• Impacto financiero de las estrategias de pricing optimizadas por IA.",
                "• Análisis de sensibilidad de precios y su efecto en el flujo de caja.",
                "• Proyecciones financieras basadas en diferentes escenarios de pricing."
            ]
        },
        {
            title: "Director y Gerente Comercial",
            consultas: [
                "• Oportunidades de crecimiento identificadas por el motor de IA.",
                "• Análisis de elasticidad de precios por segmento de cliente y canal de venta.",
                "• Recomendaciones de bundling y promociones cruzadas para maximizar el valor del cliente.",
                "• Oportunidades de cross-selling y up-selling.",
                "• Análisis de descuentos y su impacto en el margen.",
                "• Rendimiento de ventas por canal y región."
            ]
        },
        {
            title: "Director y Gerente de Planeación Financiera",
            consultas: [
                "• Pronósticos de demanda basados en diferentes estrategias de pricing.",
                "• Análisis de escenarios de precios y su impacto en los objetivos financieros a largo plazo.",
                "• Optimización del mix de productos basada en rentabilidad y demanda proyectada."
            ]
        },
        {
            title: "Director y Gerente de Marketing",
            consultas: [
                "• Análisis de la efectividad de campañas de marketing en relación con las estrategias de pricing.",
                "• Recomendaciones de precios para nuevos lanzamientos de productos.",
                "• Segmentación de clientes basada en sensibilidad al precio y comportamiento de compra."
            ]
        },
        {
            title: "Líder de eCommerce",
            consultas: [
                "• Optimización de precios en tiempo real para el canal online.",
                "• Análisis de comportamiento de abandono de carrito en relación con los precios.",
                "• Estrategias de pricing personalizadas para diferentes segmentos de clientes online."
            ]
        },
        {
            title: "Director y Gerente de Precios",
            consultas: [
                "• Dashboard completo de performance de pricing con alertas y recomendaciones de la IA.",
                "• Simulaciones de guerra de precios y estrategias de respuesta optimizadas.",
                "• Análisis de la efectividad de las reglas de pricing implementadas."
            ]
        },
        {
            title: "Analista de Precios",
            consultas: [
                "• Herramientas de modelado predictivo para análisis de escenarios de precios.",
                "• Reportes detallados de elasticidad de precios por SKU y categoría.",
                "• Alertas automáticas de anomalías en precios o comportamiento de compra."
            ]
        },
        {
            title: "Director y Gerente de Rentabilidad Comercial",
            consultas: [
                "• Análisis de contribución al margen por producto, categoría y cliente.",
                "• Optimización de la estructura de descuentos y promociones.",
                "• Identificación de oportunidades de mejora en la rentabilidad a través de ajustes de precios."
            ]
        }
    ];

    return (
        <div className="guia-container">
            <h1>Consultas sugeridas por rol o línea de negocio</h1>
            <div className="guia-list">
                {consultasPorRol.map((rol, index) => (
                    <div key={index} className="guia-item">
                        <h3 style={{ color: '#073C5C' }}>{rol.title}</h3>
                        {rol.consultas.map((consulta, idx) => (
                            <p key={idx}>{consulta}</p>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Guia;